import { createContext, useContext, useMemo } from 'react';
import { THEME_NAME, THEME_MODE } from 'foundations-theming-base/symbol';
import { getThemeMetadata } from '../../utils/themeMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
export const ThemeMetadataContext = /*#__PURE__*/createContext({
  themeName: 'canvas',
  themeMode: 'light'
});
export const ThemeMetadataContextProvider = ({
  theme,
  children
}) => {
  const memoizedValue = useMemo(() => {
    const themeWithMeta = getThemeMetadata(theme);
    return {
      themeName: (themeWithMeta === null || themeWithMeta === void 0 ? void 0 : themeWithMeta[THEME_NAME]) || 'canvas',
      themeMode: (themeWithMeta === null || themeWithMeta === void 0 ? void 0 : themeWithMeta[THEME_MODE]) || 'light'
    };
  }, [theme]);
  return /*#__PURE__*/_jsx(ThemeMetadataContext.Provider, {
    value: memoizedValue,
    children: children
  });
};

/**
 * Provides the context for theme metadata.
 * @returns themeMetadataContext - The theme metadata object.
 * @returns themeMetadataContext.themeName - The theme name.
 * @returns themeMetadataContext.themeMode - The theme mode.
 */
export const useThemeMetadata = () => {
  const themeMetadataContext = useContext(ThemeMetadataContext);
  return themeMetadataContext;
};